import { handleUpdateCommand } from './commands/grid_form_command_handler';

export default {
	execute
};

function execute(commands, { dataRow, dataRows, dataRowIdField }) {
	var dataRowToUpdate = dataRows.find(currentDataRow => currentDataRow[dataRowIdField] === dataRow[dataRowIdField]);
	dataRowToUpdate = Object.assign(dataRowToUpdate, dataRow);

	return {
		...handleUpdateCommand(commands, dataRow, dataRowIdField),
		dataRows
	};
}
